import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import './GuidesSection.css';

const GuidesSection = () => {
  const [ref, inView] = useInView({
    threshold: 0.2,
    triggerOnce: true
  });

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const checkVisibility = () => {
      const now = new Date();
      // Set the target date: October 10, 2025 at 20:00 (8 PM)
      const targetDate = new Date(2025, 9, 10, 20, 0, 0); // Month is 0-indexed, so 9 = October
      
      // Check if current time is past the target time
      setIsVisible(now >= targetDate);
    };

    // Check immediately
    checkVisibility();

    // Check every minute to update visibility
    const interval = setInterval(checkVisibility, 60000);

    return () => clearInterval(interval);
  }, []);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        delayChildren: 0.3,
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { y: 30, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.8,
        ease: "easeOut"
      }
    }
  };

  const guides = [
    {
      title: 'دليل المشاركين',
      titleEn: 'Participants Guide',
      icon: '👥',
      file: '/Participants guide encrypted new.pdf',
      description: 'كل ما تحتاج معرفته للمشاركة في الهاكاثون',
      color: '#4B4FE5'
    },
    {
      title: 'دليل المرشدين',
      titleEn: 'Mentors Guide',
      icon: '🎓',
      file: '/Mentors Guide.pdf',
      description: 'دليل شامل للمرشدين لدعم الفرق',
      color: '#FF6B6B'
    },
    {
      title: 'دليل الحكام',
      titleEn: 'Judges Guide',
      icon: '⚖️',
      file: '/Judges Guide.pdf',
      description: 'معايير التقييم وإرشادات الحكام',
      color: '#FFD93D'
    }
  ];

  const handleDownload = (file, title) => {
    // Create a temporary anchor element to trigger download
    const link = document.createElement('a');
    link.href = file;
    link.download = file.split('/').pop();
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // Don't render the section if it's not yet visible
  if (!isVisible) {
    return null;
  }

  return (
    <section className="guides-section section" id="guides">
      <div className="container">
        <motion.div 
          ref={ref}
          className="guides-content"
          variants={containerVariants}
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
        >
          <motion.h2 className="section-title" variants={itemVariants}>
            📚 الأدلة الإرشادية
          </motion.h2>
          <motion.p className="guides-subtitle" variants={itemVariants}>
            حمّل الأدلة الإرشادية لتحقيق أقصى استفادة من الهاكاثون
          </motion.p>

          <div className="guides-grid">
            {guides.map((guide, index) => (
              <motion.div
                key={index}
                className="guide-card"
                variants={itemVariants}
                whileHover={{ y: -10, scale: 1.02 }}
                style={{ '--guide-color': guide.color }}
              >
                <div className="guide-icon">{guide.icon}</div>
                <h3 className="guide-title">{guide.title}</h3>
                <p className="guide-title-en">{guide.titleEn}</p>
                <p className="guide-description">{guide.description}</p>
                <motion.button
                  className="download-button"
                  onClick={() => handleDownload(guide.file, guide.title)}
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                >
                  <span className="download-icon">⬇</span>
                  <span className="download-text">تحميل الدليل</span>
                </motion.button>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default GuidesSection;

